import React, { useEffect, useState } from "react";
import Header3 from "./Header3";
import BottomNav from "./BottomNav";
import {
  Container,
  Box,
  Card,
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate, useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useSubscriptionContext } from "./SubscriptionContext";
import { getTierInfo } from "./membershipTiers";
import ProtectedPublishButton from "./protectedPublish";

const STATUS_LABELS = {
  abierto: { label: "Abierto", color: "success" },
  en_progreso: { label: "En progreso", color: "warning" },
  cerrado: { label: "Cerrado", color: "default" },
};

function Project() {
  const { projectId } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [userType, setUserType] = useState(null);
  const [showDialogCC, setShowDialogCC] = useState(false);
  const { subscription } = useSubscriptionContext();
  const myTier = getTierInfo(subscription);

  useEffect(() => {
    const fetchUserType = async () => {
      const { uid } = auth.currentUser || {};
      if (!uid) return;
      const userDocSnap = await getDoc(doc(db, "users", uid));
      if (userDocSnap.exists()) {
        const type = userDocSnap.data().userType;
        setUserType(type);
        if (type === "freelancer" && subscription?.status !== "ACTIVE") {
          setShowDialogCC(true);
        }
      }
    };

    fetchUserType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription]);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        setLoading(true);
        const projectDocRef = doc(db, "projects", projectId);
        const projectSnapshot = await getDoc(projectDocRef);
        
        if (projectSnapshot.exists()) {
          const projectData = { id: projectSnapshot.id, ...projectSnapshot.data() };
          setProject(projectData);
        }
      } catch (error) {
        console.error("Error fetching project:", error);
      } finally {
        setLoading(false);
      }
    };

    if (projectId) {
      fetchProject();
    }
  }, [projectId]);

  const formatDate = (timeToDo) => {
    if (timeToDo instanceof Date) {
      return timeToDo.toLocaleDateString();
    } else if (timeToDo && timeToDo.toDate instanceof Function) {
      return timeToDo.toDate().toLocaleDateString();
    }
    return "";
  };

  const styles = {
    title: {
      fontSize: "24px",
      color: "primary.main",
      marginBottom: "7px",
    },
    description: {
      fontSize: "18px",
      marginBottom: "7px",
    },
    price: {
      color: "success.main",
      marginBottom: "7px",
      fontFamily: (theme) => theme.custom.fontMono,
    },
    skills: {
      marginBottom: "7px",
    },
    timeToDo: {
      color: "success.main",
      fontSize: "15px",
      marginBottom: "7px",
      fontFamily: (theme) => theme.custom.fontMono,
    },
    created: {
      fontSize: "10px",
      marginBottom: "7px",
      color: "text.secondary",
    },
  };

  return (
    <Container maxWidth="md">
      <Header3 />
      <Dialog open={showDialogCC} onClose={() => setShowDialogCC(false)}>
        <DialogTitle>¡Hazte miembro de la red!</DialogTitle>
        <DialogContent>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => {
              setShowDialogCC(false);
              navigate("/subscription");
            }}
          >
            Obtener Membresia
          </Button>
        </DialogContent>
      </Dialog>
      <Box sx={{ mt: 14, mb: 20 }}>
        {loading ? (
          <Box sx={{ textAlign: "center", color: "primary.main", marginTop: 2.5 }}>
            <CircularProgress />
          </Box>
        ) : project ? (
          <Card sx={{ p: 3, width: "87%", mx: "auto" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Typography sx={styles.title}>{project.title}</Typography>
              <Chip
                size="small"
                label={STATUS_LABELS[project.status]?.label || "Abierto"}
                color={STATUS_LABELS[project.status]?.color || "success"}
              />
            </Box>
            <Typography sx={styles.description}>{project.description}</Typography>
            <Typography sx={styles.price}>Presupuesto: USD$ {project.price}</Typography>
            <Typography sx={styles.skills}>Habilidad: {project.skills.join(", ")}</Typography>
            <Typography sx={styles.timeToDo}>
              Fecha de entrega: {formatDate(project.timeToDo)}
            </Typography>
            <Typography sx={styles.created}>
              Fecha de publicación: {project.createdAt.toDate().toLocaleDateString()}
            </Typography>
            {(project.status || "abierto") !== "abierto" && (
              <Typography color="text.secondary" sx={{ mt: 2 }}>
                Este proyecto ya no está aceptando propuestas.
              </Typography>
            )}
            {userType === "freelancer" && (project.status || "abierto") === "abierto" && (
              <Box sx={{ width: "100%" }}>
                {subscription?.status !== "ACTIVE" ? (
                  <Button
                    variant="outlined"
                    sx={{ mt: 2 }}
                    fullWidth
                    onClick={() => navigate("/subscription")}
                  >
                    Hazte miembro y envía una propuesta
                  </Button>
                ) : myTier.maxProjectBudget >= (Number(project.price) || 0) ? (
                  <ProtectedPublishButton projectId={project.id}>
                    Enviar una propuesta
                  </ProtectedPublishButton>
                ) : (
                  <Button
                    variant="outlined"
                    color="warning"
                    sx={{ mt: 2 }}
                    fullWidth
                    startIcon={<LockIcon />}
                    onClick={() => navigate("/subscription")}
                  >
                    Necesitás un plan superior para este proyecto
                  </Button>
                )}
              </Box>
            )}
          </Card>
        ) : (
          <Typography>No se encontró el proyecto.</Typography>
        )}
      </Box>
      <BottomNav />
    </Container>
  );
}

export default Project;